module.exports = __webpack_public_path__ + "img/20190830150216648.fe25249a.jpg";